// Income statement and trial balance (en).
window.PlummeI18n.register('en', {
  'rep.zeroHidden': 'Accounts have zero balance in this period. Show them using Filters.',
  'rep.showZero': 'Show accounts with zero balance',
  'rep.group.tax': 'INCOME TAX EXPENSE',
  'rep.group.dispositions': 'APPROPRIATIONS',
  'rep.trial.titleHelp': 'The trial balance lists every account in the chart of accounts with its balance for the selected period. Tap an account line to see the vouchers posted to it.',
  'rep.trial.viewHelp': 'By default the trial balance only shows active accounts — accounts with a balance or movement. "Also show inactive accounts" adds the rest of the chart of accounts, and "Only show accounts with movement" requires the account to have postings in the period. Show as chooses whether amounts appear with decimals, as whole amounts or in thousands.',
  'rep.trial.empty': 'No posted balances for the selected period.',
  'rep.trial.oneSupplier': '1 supplier',
  'rep.trial.supplierCount': '{n} suppliers',
  'rep.trial.oneCustomer': '1 customer',
  'rep.trial.customerCount': '{n} customers',
  'rep.trial.oneOpenCustomerItem': '1 open item',
  'rep.trial.openCustomerItems': '{n} open items',
  'rep.trial.customerDifference': 'Other postings / reconciliation difference',
  'rep.trial.noCustomerBalances': 'No customer balances in the selected view.',
  'rep.trial.oneOpenSupplierItem': '1 open item',
  'rep.trial.openSupplierItems': '{n} open items',
  'rep.trial.supplierDifference': 'Other postings / reconciliation difference',
  'rep.trial.noSupplierBalances': 'No supplier balances in the selected view.',
  'rep.trial.exportTitle': 'Trial balance: {column}',
  'rep.group.assets': 'ASSETS',
  'rep.group.equityLiabilities': 'EQUITY / LIABILITIES',
  'rep.group.operatingIncome': 'OPERATING INCOME',
  'rep.group.operatingCosts': 'OPERATING EXPENSES',
  'rep.groupTotal': 'Total {group}',
  'rep.balance.opening': 'Opening',
  'rep.balance.movement': 'Change',
  'rep.balance.closing': 'Closing',
  'rep.showAs.withDecimals': 'With decimals',
  'rep.showAs.whole': 'Whole amounts',
  'rep.showAs.thousands': 'Thousands',
  'rep.result.titleHelp': 'The income statement shows income and expenses for the period and what is left as the result. Open a section to see the accounts behind the figures, and tap an account line to see the vouchers posted there.',
  'rep.result.subtitle': 'Start with the summary and open account details when you need them.',
  'rep.result.income': 'Operating income',
  'rep.result.costs': 'Operating expenses',
  'rep.result.finance': 'Financial items',
  'rep.result.beforeTax': 'Profit before tax',
  'rep.result.noLines': 'No activity on these accounts yet.',
  'rep.total': 'Total',
  'rep.showDetails': 'Show details',
  'rep.hideDetails': 'Hide details',
  'rep.shareOfLargest': '{pct} % of the largest item',
  'rep.showVouchersFor': 'Show all vouchers on {account}',
  'rep.period.otherYear': 'Showing figures for the {year} financial year.',
  'rep.period.singleYear': 'The period spans two financial years. Reports are calculated per financial year with the opening balance from the start of the year, so choose a period within one year.',
  'rep.export.busy': 'Exporting...',
  'rep.export.downloaded': '{format} downloaded',
  'rep.export.failed': 'Could not export the report.',
  'rep.export.pdfUnavailable': 'Report PDF is not connected to the backend.',
  'rep.export.year': 'Year',
  'rep.export.period': 'Period',
  'rep.export.summary': 'Summary',
  'rep.export.item': 'Item',
  'rep.export.amount': 'Amount',
  'rep.accountHelp.receivables': 'Accounts receivable is money customers owe you for invoices that have not been paid yet.',
  'rep.accountHelp.bank': 'Bank deposits shows the money in the operating account.',
  'rep.accountHelp.payables': 'Accounts payable is invoices and purchases you owe suppliers.',
  'rep.accountHelp.outputVat': 'Output VAT is the VAT you have charged on sales.',
  'rep.accountHelp.inputVat': 'Input VAT is the VAT you have paid on purchases and can normally deduct.',
  'rep.accountHelp.vatSettlement': 'The VAT settlement account shows the net VAT you owe or are owed.',
  'rep.accountHelp.vatableSales': 'Sales revenue subject to VAT shows ordinary sales where output VAT is charged.',
  'rep.accountHelp.group.asset': 'Asset account: values the business owns or is owed.',
  'rep.accountHelp.group.equityLiability': 'Equity or liability: financing, amounts owed and settlement items.',
  'rep.accountHelp.group.income': 'Income account: sales and other income in the business.',
  'rep.accountHelp.group.goods': 'Cost of goods: costs related to goods, raw materials or resale.',
  'rep.accountHelp.group.payroll': 'Payroll expense: salaries, holiday pay and staff-related benefits.',
  'rep.accountHelp.group.operating': 'Operating expense: the costs of running the business.',
  'rep.accountHelp.group.finance': 'Finance or tax account: interest, financial items or tax expense.',
  'rep.accountHelp.other': 'Account {account} in the chart of accounts.',
  'rep.accountHelp.openVouchers': 'Tap the account line to see all vouchers posted to this account.',
  'rep.dimensions.title': 'Project and department',
  'rep.dimensions.help': 'Filter the report without changing source data. The entire voucher is retained, including counterpart lines.',
  'rep.dimensions.project': 'Project',
  'rep.dimensions.department': 'Department',
  'rep.dimensions.all': 'All',
  'rep.dimensions.unassigned': 'Unassigned',
  'rep.incompleteBasisTitle': 'The accounting basis is incomplete',
  'rep.journalLoading': 'Loading the accounting journal …',
  'rep.incompleteBasisText': 'The report is not presented as complete because journal coverage or required opening data has not been documented. Available evidence is retained for review.',
  'rep.importedBasisTitle': 'Imported accounting statistics.',
  'rep.importedBasisText': 'These figures come from validated imported account statistics, not journal entries in Plumme. They remain uncertified and cannot be used for filing, payment certification or year closing.',
  'rep.importedBasisExport': 'Validated imported account statistics; not journal-complete or certified.',
});
